import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import {
  DigitalPublicationSection,
  IDigitalPublicationSection,
} from 'src/app/core/dtos/interfaces/i-digital-publication-section';
import { DigitalPublicationSectionEvent } from 'src/app/core/dtos/interfaces/i-digital-publication-section-event';

@Component({
  selector: 'app-digital-publication-section-list',
  templateUrl: './digital-publication-section-list.component.html',
  styleUrls: ['./digital-publication-section-list.component.scss'],
})
export class DigitalPublicationSectionListComponent implements OnInit {
  @Input() sectionArray: FormArray<FormControl<IDigitalPublicationSection>>;
  @Input() urlPath: FormControl<string>;
  @Input() isDisabled = false;

  changingSectionOrder$ = new Subject<boolean>();

  ngOnInit(): void {
    this.checkSectionIds();
  }

  checkSectionIds(): void {
    this.sectionArray.controls.forEach((section) => {
      if (section.value.id === 0) {
        section.value.id = this.calculateNewSectionId(1);
      }
    });
  }

  drop(event: CdkDragDrop<any>) {
    if (this.isDisabled) {
      return;
    }

    this.handleSectionOrder(event.previousIndex, event.currentIndex);
  }

  sectionOrderChanged(sectionIndexes: number[]): void {
    this.changingSectionOrder$.next(true);
    let newSectionIndex = sectionIndexes[0] - 1;
    let previousIndex = sectionIndexes[1] - 1;

    if (
      newSectionIndex === previousIndex ||
      newSectionIndex < 0 ||
      sectionIndexes[0] > this.sectionArray.length ||
      sectionIndexes[1] > this.sectionArray.length
    ) {
      return;
    }

    this.handleSectionOrder(previousIndex, newSectionIndex);
  }

  handleSectionOrder(previousIndex, nextIndex): void {
    moveItemInArray(this.sectionArray.controls, previousIndex, nextIndex);
    this.restoreSectionOrder();
  }

  restoreSectionOrder(): void {
    this.sectionArray.controls.forEach((section, index) => {
      var newSection = section;
      newSection.value.order = index + 1;
      section.setValue(newSection.value);
    });
    setTimeout(() => {
      this.changingSectionOrder$.next(false);
    }, 0);
  }

  createNewSection(): void {
    var index = this.sectionArray.length ? this.sectionArray.length + 1 : 1;
    var newSection = new DigitalPublicationSection(
      this.calculateNewSectionId(index),
      index
    );

    this.sectionArray.push(new FormControl(newSection));

    this.restoreSectionOrder();
  }

  calculateNewSectionId(index: number): number {
    let idList = this.sectionArray.controls.map((section) => section.value.id);
    while (idList.includes(index)) {
      index++;
    }
    return index;
  }

  removeSectionClick(slideIndex: number): void {
    this.sectionArray.removeAt(slideIndex);
    this.restoreSectionOrder();
  }

  sectionChanged(event: DigitalPublicationSectionEvent): void {
    this.sectionArray.controls.forEach((section) => {
      if (section.value.id === event.value.id) {
        section.setValue(event.value);
      }
    });
    this.restoreSectionOrder();
  }

  dragStarted() {
    this.changingSectionOrder$.next(true);
  }
}
